module.exports = __webpack_public_path__ + "94f9066b0601019b64ddaae2600c7035.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/profiles/social/social.html
// module id = 2350
// module chunks = 0